import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineClassesAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  if (permissions.some(p => [
    AuthAuthPermissions.DATA_UPLOAD,
    AuthAuthPermissions.PROJECT_CREATION,
  ].includes(p))) {
    can('crud', 'Class')
  }
}
